module.exports = __webpack_public_path__ + "img/icon-coin2.783aba7b.png";